module.exports = __webpack_public_path__ + "img/moble_home3.a9672973.png";